// VITE_BACKEND_BASE_URL already includes the /api/v1 base path, so endpoint
// paths must be relative to it (matching kybModulePolicyEndpoints).
const secretEncryptionEndpoints = {
  encrypt: () => "/admin/secrets/encrypt",
};

export default secretEncryptionEndpoints;
